import React, { memo } from 'react';
import { ScreenExternalVideoItem } from '@modules/learning/types/objects';
import VideoPreview from '@common/components/video';

type ExternalVideoEmbedProps = {
  item: ScreenExternalVideoItem;
};

const ExternalVideoEmbed = memo((props: ExternalVideoEmbedProps) => {
  const attachment = props?.item?.parameters?.attachment;
  const videoId = attachment?.video_id;
  const thumb = attachment?.thumb_path;

  if (!videoId) return null;

  const youtubeUrl = `https://www.youtube.com/watch?v=${videoId}`;

  return (
    <div className="tw-rounded-lg tw-overflow-hidden">
      <VideoPreview
        id={`external-video-${props?.item?.id}`}
        path={youtubeUrl}
        thumb={thumb}
        className="tw-rounded-lg"
      />
    </div>
  );
});

export default ExternalVideoEmbed;
